var Structure = function() {

	var comp = $('[data-component="structure"]');

	this.init = function() {

		// $('.scrollbar-inner').scrollbar();

	}

	return this.init();

}
